// extracted by mini-css-extract-plugin
export default {"reCaptchaErrorForNewUi":"c-b_P"};